"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const CoreContext_1 = require("../../contexts/CoreContext");
const JoinLauncherContext_1 = require("../../contexts/join-launcher/JoinLauncherContext");
const ButtonsFactory_1 = require("../../helpers/ButtonsFactory");
const teamsLogoImg = require("../../images/v2/logo_teams.svg");
const DownloadState_1 = require("../../models/DownloadState");
const Environment_1 = require("../../models/Environment");
const JoinInfo_1 = require("../../models/JoinInfo");
const TelemetryEvents_1 = require("../../models/telemetry/TelemetryEvents");
const DownloadService_1 = require("../../services/DownloadService");
const Logger_1 = require("../../services/Logger");
const Footer_1 = require("../common/Footer");
const TeamsLogo_1 = require("../common/TeamsLogo");
const InstallPrompt_1 = require("./InstallPrompt");
require("./ModernViewContainer.scss");
const ModernViewRenderer_1 = require("./ModernViewRenderer");
const RootView_1 = require("./RootView");
const lastTimeUserEngagement = "lastTimeUserEngagement";
class ModernViewContainer extends React.Component {
    constructor(props) {
        super(props);
        this.pstnAvailabilityChecked = false;
        this.state = {
            pstnIsAvailable: undefined,
        };
    }
    render() {
        return (React.createElement(CoreContext_1.CoreContextConsumer, null, ({ environment, launcherService, featureFlags }) => {
            let waitsForLWJCheck = false;
            if (this.props.type === RootView_1.ModernViewType.Meeting) {
                this.checkPstnAvailability(environment, launcherService);
                waitsForLWJCheck = environment.isLWJSupportedBrowser && featureFlags.enableLWJ;
            }
            return (React.createElement(JoinLauncherContext_1.JoinLauncherContextConsumer, null, ({ joinInfo, downloadState }) => {
                const showDesktopButtons = !(joinInfo.type === JoinInfo_1.JoinType.MeetupWithCode && featureFlags.disableTfLDesktop);
                const buttonsFactory = new ButtonsFactory_1.ButtonsFactory({ meeting: this.props.type === RootView_1.ModernViewType.Meeting, showDesktopButtons,
                    hideDownloadButton: environment.isTflDomain && featureFlags.hideDownloadButtonOnTfl && environment.isWindows10,
                    isWindowsTfwUI: !environment.isTflDomain && featureFlags.enableWindowsTfwUI }, this.getButtonHandlers(environment, featureFlags, launcherService, joinInfo, downloadState));
                return (React.createElement("div", { className: "modernViewContainer" },
                    React.createElement(TeamsLogo_1.TeamsLogo, { src: teamsLogoImg }),
                    React.createElement("div", { id: "container" },
                        React.createElement(ModernViewRenderer_1.ModernViewRenderer, { buttonsFactory: buttonsFactory, showContinueInBrowser: this.shouldShowContinueInBrowser(environment, featureFlags), waitsForLWJCheck: !!waitsForLWJCheck, pstnIsAvailable: this.state.pstnIsAvailable, launchResult: this.props.launchResult, launchMethod: launcherService.getLaunchMethod(), enableVariant10: featureFlags.enableVariant10 && !featureFlags.suppressPrompt, installerAutoDownloadEnabled: featureFlags.enableAutoDownload && joinInfo.isAutoDownloaderTriggered })),
                    React.createElement(Footer_1.Footer, { className: "disclaimer", onLinkClick: () => Logger_1.default.logUserBiPanelAction(new TelemetryEvents_1.PanelActionEvent(TelemetryEvents_1.PanelActionScenarioNames.ModernView, TelemetryEvents_1.ModuleNames.ShowThirdPartyNotice, joinInfo)) }),
                    this.shouldShowDownloadInProgress(downloadState) ?
                        React.createElement(InstallPrompt_1.InstallPrompt, { browser: environment.browserName, text: "txt_during_download_v2", renderText: this.shouldRenderInstallPromptText() }) : null));
            }));
        }));
    }
    shouldShowDownloadInProgress(downloadState) {
        return downloadState.step === DownloadState_1.DownloadStep.InProgress || downloadState.step === DownloadState_1.DownloadStep.PotentiallyCompleted;
    }
    shouldRenderInstallPromptText() {
        return (this.props.type !== RootView_1.ModernViewType.FreemiumOnboarding &&
            this.props.type !== RootView_1.ModernViewType.ShareEmail);
    }
    checkPstnAvailability(environment, launcherService) {
        if (environment.isLWJSupportedBrowser && !this.pstnAvailabilityChecked) {
            launcherService.getPstnAvailability().then((value) => {
                this.setPstnIsAvailableState(value);
            }).catch(() => {
                this.setPstnIsAvailableState(false);
            });
        }
        this.pstnAvailabilityChecked = true;
    }
    setPstnIsAvailableState(pstnIsAvailable) {
        const event = new TelemetryEvents_1.PstnJoinAvailable({ pstnIsAvailable });
        Logger_1.default.log(event);
        this.setState({ pstnIsAvailable });
    }
    shouldShowContinueInBrowser(environment, featureFlags) {
        switch (this.props.type) {
            case RootView_1.ModernViewType.Meeting:
                return environment.isLWJSupportedBrowser && featureFlags.enableLWJ && !!this.state.pstnIsAvailable;
            case RootView_1.ModernViewType.ShareEmail:
                return environment.browserName !== Environment_1.Browsers.MSIE;
            default:
                return false;
        }
    }
    // Task: https://domoreexp.visualstudio.com/MSTeams/_workitems/edit/2097067
    markVisitors(enableVisitorMarking, isTflDomain) {
        const notVisited = !window.localStorage.getItem(lastTimeUserEngagement);
        if (enableVisitorMarking && notVisited && !isTflDomain) {
            window.localStorage.setItem(lastTimeUserEngagement, Date.now().toString());
        }
    }
    getButtonHandlers(environment, featureFlags, launcherService, joinInfo, downloadState) {
        const downloadBehavior = DownloadService_1.default.getDownloadBehaviour(joinInfo, environment, featureFlags, launcherService, downloadState);
        const handlers = {
            download: () => {
                const panelActionEvent = new TelemetryEvents_1.PanelActionEvent(TelemetryEvents_1.PanelActionScenarioNames.ModernView, TelemetryEvents_1.ModuleNames.Download, joinInfo);
                Logger_1.default.logUserBiPanelAction(panelActionEvent);
                if (downloadBehavior) {
                    this.markVisitors(featureFlags.enableVisitorMarking, environment.isTflDomain);
                    downloadBehavior.onClick();
                }
            },
            redirectToDownloadPage: () => {
                const panelActionEvent = new TelemetryEvents_1.PanelActionEvent(TelemetryEvents_1.PanelActionScenarioNames.ModernView, TelemetryEvents_1.ModuleNames.Download, joinInfo);
                Logger_1.default.logUserBiPanelAction(panelActionEvent);
                this.markVisitors(featureFlags.enableVisitorMarking, environment.isTflDomain);
                launcherService.redirectToDownloadPage();
            },
            joinOnWeb: () => {
                const panelActionEvent = new TelemetryEvents_1.PanelActionEvent(TelemetryEvents_1.PanelActionScenarioNames.ModernView, TelemetryEvents_1.ModuleNames.JoinOnWeb, joinInfo);
                Logger_1.default.logUserBiPanelAction(panelActionEvent);
                this.markVisitors(featureFlags.enableVisitorMarking, environment.isTflDomain);
                launcherService.redirectToWebJoin();
            },
            redirectToEdge: () => {
                const panelActionEvent = new TelemetryEvents_1.PanelActionEvent(TelemetryEvents_1.PanelActionScenarioNames.ModernView, TelemetryEvents_1.ModuleNames.RedirectToEdge, joinInfo);
                Logger_1.default.logUserBiPanelAction(panelActionEvent);
                this.markVisitors(featureFlags.enableVisitorMarking, environment.isTflDomain);
                launcherService.redirectToWebJoin(undefined, true);
            },
            joinInApp: () => {
                const panelActionEvent = new TelemetryEvents_1.PanelActionEvent(TelemetryEvents_1.PanelActionScenarioNames.ModernView, TelemetryEvents_1.ModuleNames.JoinInApp, joinInfo);
                Logger_1.default.logUserBiPanelAction(panelActionEvent);
                this.markVisitors(featureFlags.enableVisitorMarking, environment.isTflDomain);
                this.props.onLaunchClick();
            },
        };
        return handlers;
    }
}
exports.ModernViewContainer = ModernViewContainer;
